import React from "react";

export default function VideoPane({
  isHost,
  video,
  mp4Ref,
  setMp4Ready,
  onMp4Play,
  onMp4Pause,
  hostSeek,
  viewerTapToStart,
}) {
  const parent = (() => {
    try {
      const cap = window.Capacitor;
      const isNative =
        !!cap &&
        typeof cap.getPlatform === "function" &&
        cap.getPlatform() !== "web";
      if (isNative) return "watchpartyrooms.com";
      return window.location.hostname || "localhost";
    } catch {
      return "watchpartyrooms.com";
    }
  })();

  const isLive = video?.type === "twitch" || video?.type === "kick";

  const twitchParents = (() => {
    const base = ["watchpartyrooms.com", "www.watchpartyrooms.com"];

    try {
      const h = String(parent || "").trim().toLowerCase();
      if (h && h !== "localhost" && h !== "127.0.0.1" && !base.includes(h)) {
        base.push(h);
      }
    } catch {}

    return base.map((p) => `parent=${encodeURIComponent(p)}`).join("&");
  })();

  const twitchSrc =
    video?.type === "twitch"
      ? `https://player.twitch.tv/?channel=${encodeURIComponent(
          video.channel || ""
        )}&${twitchParents}&autoplay=false`
      : null;

  const kickSrc =
    video?.type === "kick"
      ? `https://player.kick.com/${encodeURIComponent(video.channel || "")}`
      : null;

  const playerKey = (() => {
    if (!video) return "none";
    if (video.type === "youtube") return `yt:${video.videoId || video.url || ""}`;
    if (video.type === "twitch") return `tw:${video.channel || video.url || ""}`;
    if (video.type === "kick") return `kick:${video.channel || video.url || ""}`;
    if (video.type === "mp4") return `mp4:${video.url || ""}`;
    return `other:${video.url || ""}`;
  })();

  return (
    <div className="videoShellClean">
      {!video ? (
        <div className="videoEmpty">
          {isHost
            ? "Set a link above"
            : "Waiting for the host to set a video..."}
        </div>
      ) : video.type === "mp4" ? (
        <div key={playerKey} className="videoFrame">
          <video
            className="videoEl"
            ref={mp4Ref}
            src={video.url}
            controls={isHost}
            playsInline
            onLoadedMetadata={() => setMp4Ready(true)}
            onPlay={isHost ? onMp4Play : undefined}
            onPause={isHost ? onMp4Pause : undefined}
            onSeeked={isHost ? hostSeek : undefined}
            style={{ pointerEvents: isHost ? "auto" : "none" }}
          />
        </div>
      ) : video.type === "twitch" ? (
        <div key={playerKey} className="videoFrame">
          <iframe
            title="twitch-player"
            src={twitchSrc}
            allow="autoplay; fullscreen"
            allowFullScreen
            frameBorder="0"
            scrolling="no"
            style={{ width: "100%", height: "100%" }}
          />
        </div>
// FILE: client/src/components/VideoPane.js
// REPLACE ONLY the KICK iframe block with this

) : video.type === "kick" ? (
  <div key={playerKey} className="videoFrame">
    <iframe
      title="kick-player"
      src={`${kickSrc}${kickSrc.includes("?") ? "&" : "?"}autoplay=false`}
      allow="autoplay; fullscreen; microphone; camera"
      allowFullScreen
      frameBorder="0"
      scrolling="no"
      playsInline
      style={{ width: "100%", height: "100%" }}
    />
  </div>
      ) : (
        <div key={playerKey} className="videoFrame">
          <div
            id="yt-player"
            style={{
              width: "100%",
              height: "100%",
              pointerEvents: isHost ? "auto" : "none",
            }}
          />
        </div>
      )}

      {!!video && !isHost && !isLive && (
        <div className="videoTapFix">
          <button onClick={viewerTapToStart} className="btn btn-primary">
            Tap to start video
          </button>
        </div>
      )}
    </div>
  );
}